import { setMinutes } from "date-fns/setMinutes";
import { setHours } from "date-fns/setHours";
import { de as LocaleDe } from "date-fns/locale/de";
import { fr as LocaleFr } from "date-fns/locale/fr";
import { es as LocaleEs } from "date-fns/locale/es";
import { it as LocaleIt } from "date-fns/locale/it";
import { nl as LocaleNl } from "date-fns/locale/nl";
import { enUS as LocaleEn } from "date-fns/locale/en-US";
export var dateLocales = {
    de: LocaleDe,
    fr: LocaleFr,
    es: LocaleEs,
    it: LocaleIt,
    nl: LocaleNl,
    en: LocaleEn
};
export var addTimeToDate = function(date, hours, minutes) {
    return setMinutes(setHours(date, hours), minutes);
};
